var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMorocco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 39.9999C31.0454 39.9999 39.9998 31.0456 39.9998 19.9999C39.9998 8.95424 31.0454 -6.10352e-05 19.9998 -6.10352e-05C8.95406 -6.10352e-05 -0.000244141 8.95424 -0.000244141 19.9999C-0.000244141 31.0456 8.95406 39.9999 19.9998 39.9999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8194 16.4132H22.7901L20 7.82605L17.2098 16.4132H8.1806L15.4854 21.7204L12.6951 30.3078L20 25.0006L27.3048 30.3079L24.5146 21.7205L31.8194 16.4132ZM17.5298 21.0561L18.4733 18.1523H21.5265L22.4701 21.0561V21.0562L20 22.8508L17.5299 21.0562L17.5298 21.0561ZM20.9615 16.4132H19.0385L20 13.4539L20.9615 16.4132ZM23.9494 19.9814L23.3551 18.1524H26.4668L23.9494 19.9814ZM16.6447 18.1524L16.0504 19.9814L13.533 18.1524H16.6447ZM16.0032 25.7547L16.9647 22.7954L18.5206 23.9257L16.0032 25.7547ZM21.4794 23.9258L23.0352 22.7955L23.9968 25.7548L21.4794 23.9258Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorocco);
export default __webpack_public_path__ + "static/media/morocco.9ded13a0da07b2569aeaa17deee3ff2f.svg";
export { ForwardRef as ReactComponent };